export default function () {
  const innovationSection = document.querySelector('[data-innovation]');
  if (!innovationSection) return;

  const innovationTitlesContainer = innovationSection.querySelector('[data-innovation-titles]');
  const innovationTitles = innovationTitlesContainer.querySelectorAll('*');

  const innovationParagraphsContainer = innovationSection.querySelector('[data-innovation-paragraphs]');
  const innovationParagraphs = innovationParagraphsContainer.querySelectorAll('*');

  let activeIndex = 0;
  let previousIndex = activeIndex;

  const animationClasses = ['transition-opacity-transform', 'duration-300'];
  const fadeOutClasses = ['-translate-x-1/2', 'opacity-0', 'absolute', 'top-0', 'left-0'];
  const fadeInClasses = ['opacity-0', 'translate-x-1/2'];

  const fadeOutEnded = (event) => {
    animationClasses.concat(fadeOutClasses).forEach(c => event.target.classList.remove(c));
    event.target.classList.add('hidden');
  };

  const fadeInEnded = (event) => {
    animationClasses.forEach(c => event.target.classList.remove(c));
  };

  const onScroll = function() {
    innovationParagraphs.forEach((paragraph, index) => {
      const paragraphPosition = paragraph.getBoundingClientRect().top;
      if (!window.matchMedia('(min-width: 1024px)').matches) {
        if (paragraphPosition <= (300)) {
          activeIndex = index;
        }
      } else {
        if (paragraphPosition <= (window.innerHeight / 2.5)) {
          activeIndex = index;
        }
      }
    });

    if (activeIndex !== previousIndex) {
      const previousTitle = innovationTitles[previousIndex];
      const nextTitle = innovationTitles[activeIndex];

      innovationTitles.forEach((title, index) => {
        title.removeEventListener('transitionend', fadeOutEnded);
        title.removeEventListener('transitionend', fadeInEnded);
        animationClasses.concat(fadeOutClasses).concat(fadeInClasses).forEach(c => title.classList.remove(c));
        if (index === previousIndex) {
          title.classList.remove('hidden');
        } else {
          title.classList.add('hidden');
        }
      });

      previousTitle.addEventListener('transitionend', fadeOutEnded, { once: true });
      animationClasses.concat(fadeOutClasses).forEach(c => previousTitle.classList.add(c));

      nextTitle.classList.remove('hidden');
      animationClasses.concat(fadeInClasses).forEach(c => nextTitle.classList.add(c));
      nextTitle.addEventListener('transitionend', fadeInEnded, { once: true });
      setTimeout(() => {
        fadeInClasses.forEach(c => nextTitle.classList.remove(c));
      }, 1);

      innovationParagraphs[previousIndex].classList.remove('font-normal');
      innovationParagraphs[activeIndex].classList.add('font-normal');
    }

    previousIndex = activeIndex;
  };

  document.addEventListener("scroll", onScroll);
  onScroll();
}
